import { Box, Typography } from '@mui/material';
import BasePageContainer from 'components/views/RegisterValidationComp/PageSuccessAndErrors/BasePageContainer';

import { ReactComponent as IcChatWhatsapp } from 'assets/icons/ic-chat-whatsapp.svg';
import { ReactComponent as IcIturinInstallationDone } from 'assets/icons/ic-iturin-confused.svg';

const ErrorGeneral = () => {
    return (
        <BasePageContainer>
            <Box sx={{
                display: 'grid',
                textAlign: 'center',
                paddingBottom: '1rem',
                justifyItems: 'center'
            }}>
                <Box sx={{
                    'svg': {
                        display: { xs: 'none', md: 'block' }
                    }
                }}>
                    <IcIturinInstallationDone />
                </Box>
                <Typography fontWeight={700} lineHeight='1.2' textTransform='uppercase' textAlign='center' sx={{
                    maxWidth: { xs: '11.6rem', md: 'fit-content' },
                    fontSize: { xs: '1.375rem', md: '1.875rem' },
                    paddingTop: '.875rem',
                    'b': {
                        color: 'primary.light'
                    }
                }}>
                    INSTALAÇÃO <b>NÃO</b> REALIZADA!
                </Typography>

                <Typography margin='0 auto' lineHeight='1.1' sx={{
                    maxWidth: { xs: '20rem', md: '27rem' },
                    padding: '1.25rem 0 1.56rem',
                    fontSize: { xs: '.9375rem', md: '1rem' }
                }}>
                    Entendemos que imprevistos acontecem e a instalação não pôde ser realizada conforme o planejado.
                    <br />
                    <br />
                    <b>Reagendar é fácil!</b> Basta nos chamar no WhatsApp e resolva tudo de forma rápida e sem complicações:
                </Typography>

                <Box>
                    <a href='https://api.whatsapp.com/send/?phone=551136169000' target='blank'>
                        <IcChatWhatsapp />
                    </a>
                    <Typography lineHeight='1.6' fontSize='1.125rem' sx={{
                        'span': {
                            fontSize: '.9375rem',
                        }
                    }}>
                        <span>opção: Reagendamento</span>
                        <br />
                        Segunda à sexta: <b>8h às 18h</b>
                        <br />
                        Sábado: <b>8h às 14h</b>
                    </Typography>
                </Box>
            </Box>
        </BasePageContainer>
    );
}

export default ErrorGeneral;